/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Logo, BurgerButton } from "@ht/components";
import UserDropdown from "../../../components/dropdown/user";
import PresenceDropdown from "../../../components/dropdown/presence";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import SignalIndicator from "../../../components/signal";
import PresenceSwitch from "../../../components/presence-switch";
import * as userstateActions from "../../../app/userState/userStateSlice";
import { useHttpRequest } from "../../../hooks/useHttpRequest";
import moment from "moment";
import { MessageBox } from "../../../components/message-box";
import { useNavigate } from "react-router-dom";
import MainMenu from "../main-menu";
import NotificationInternalDropdown from "../../../components/dropdown/notification-internal";
import MobileMenu from "../mobile-menu";
import { vCallSetAvailable, vCallWSStartConnecting } from "../../../app/videocall/videoSlice";
import { callSetAvailable, callWSStartConnecting, callWSDisconnect } from "../../../app/call/callSlice";
import * as chatActions from "../../../app/chat/chatSlice";

const Header = () => {
  const incomingcallcontrol = <></>;
  const [offcanvas, setOffcanvas] = useState(false);
  const offcanvasHandler = () => {
    setOffcanvas((prev) => !prev);
  };

  const { user, navigations } = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const { callpresence } = useAppSelector((state) => state.userstate);
  const { vCallAvailable: vcallConnected } = useAppSelector(
    (state) => state.vcall
  );
  const { allowReceiveChat: chatConnected, connected: chatServerConnected } =
    useAppSelector((state) => state.chat);
  const { callAvailable: sipConnected, logout } = useAppSelector(
    (state) => state.call
  );
  const { ping: _ping } = useAppSelector((state) => state.userstate);
  const { vCallAvailable } = useAppSelector((state) => state.vcall);
  const [ping, setPing] = useState(0);
  const [reason, setReason] = useState("init");
  const [reasonLabel, setReasonLabel] = useState("");
  const [reasonTime, setReasonTime] = useState(moment().unix());
  const [onlineStatus, setOnlineStatus] = useState("connecting");
  const [isExpired, setIsExpired] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const expiredMsg =
    "Your password will be expired soon, please change your password";
  const firstloginMsg =
    "You logged in to a new account, please change your default password";

  const dispatch = useAppDispatch();

  const { sendRequest } = useHttpRequest();
  const UpdatePresence = async (status: string, rsn: string) => {
    if (user && status !== "connecting") {
      const baseUrl = String(process.env.REACT_APP_ROUTING_SERVICE);
      const payload = {
        tenant_id: user?.tenantId,
        device_id: user?.deviceId,
        status: status,
        device_info: rsn == " " ? "online" : rsn,
        presence_time: moment().toDate(),
        username: user?.username,
      };
      await sendRequest({
        baseUrl: baseUrl,
        url: `presence`,
        method: "post",
        body: payload,
      });
    } else if (onlineStatus === "connecting") {
      setOnlineStatus("connecting");
    } else {
      setOnlineStatus("offline");
    }
  };
  const getLabelAux = async () => {
    const baseUrl = String(process.env.REACT_APP_ROUTING_SERVICE);
    const result = await sendRequest({
      baseUrl: baseUrl,
      url: `presence/aux/label/${user?.tenantId}/${user?.deviceInfo}`,
      method: "get",
    });
    if(result?.data && result?.data?.length > 0){
      setReasonLabel(result?.data as any);
    }
    else{
      setReasonLabel(user?.deviceInfo as any);
    }
  };
  const UpdateAvailability = async (rsn: string) => {
    if (user) {
      const baseUrl = String(process.env.REACT_APP_ROUTING_SERVICE);
      const payload = {
        tenant_id: user?.tenantId,
        device_id: user?.deviceId,
        device_info: rsn,
        presence_time: moment().toDate(),
        username: user?.username,
      };
      await sendRequest({
        baseUrl: baseUrl,
        url: `presence/oncall`,
        method: "post",
        body: payload,
      });
    }
  };
  const onlineState = () => {
    dispatch(userstateActions.setAvailable(true));
    dispatch(userstateActions.setOnCall(""));
    dispatch(callSetAvailable(true));
    dispatch(vCallSetAvailable(true));
    dispatch(chatActions.chatWSOnline());
    setOnlineStatus("online");
    setReason("online");
    setReasonLabel("");
    if (!vCallAvailable)
      dispatch(vCallWSStartConnecting());
    dispatch(callWSStartConnecting());
  }
  const offlineState = () => {
    setOnlineStatus("offline");
    dispatch(callSetAvailable(false));
    dispatch(vCallSetAvailable(false));
    dispatch(callWSDisconnect());
    dispatch(userstateActions.setAvailable(false));
    dispatch(chatActions.chatWSOffline());
  }
  useEffect(() => {
    UpdatePresence(onlineStatus, reason).catch((err) => {
      console.log(err);
    });
  }, [onlineStatus, reason]);
  useEffect(() => {
    console.log("CALLPRESENCE>>", `[${callpresence?.trim() != " "}]`)
    if (callpresence != " ")
      UpdateAvailability(callpresence).catch((err) => {
        console.log(err);
      });
    setReasonTime(moment().unix());
  }, [callpresence]);

  const ChangeState = (value: string, label: string) => {
    console.log("label state", value, label);
    setOnlineStatus("connecting");
    setReason(value);
    setReasonLabel(label);
    setReasonTime(moment().unix());
    const status = value === "" ? "online" : "offline";

    if (status === "online") {
      onlineState();
    } else {
      offlineState();
    }
  };
  useEffect(() => {
    console.log(
      "chat connected, vcall, or sip, or user",
      chatConnected,
      vcallConnected,
      sipConnected,
      onlineStatus
    );
    if (user && user?.status != "offline") {
      if ((chatConnected || vcallConnected || sipConnected) && (onlineStatus === "online" || onlineStatus === "connecting")) {
        setReason("online");
        setOnlineStatus("online");
        setReasonLabel("");
      }
    }
    else if (user && user?.status === "offline" && onlineStatus != "online") {
      setOnlineStatus("offline");
      setReason(user?.deviceInfo);
      getLabelAux().catch((e) => console.log("error get label aux: ", e));
    }
  }, [chatConnected, vcallConnected, sipConnected, user]);

  useEffect(() => {
    setPing(_ping);
  }, [_ping]);
  useEffect(() => {
    //remove for demo purpose
    // const logoutTime = setTimeout(() => {
    //   if (logout) {
    //     dispatch(logoutIncomingMessageReceived(false));
    //     dispatch(logoutEvent())
    //     navigate("/signout");
    //   }
    // }, 10000);
    //return () => clearTimeout(logoutTime);
  }, [logout]);

  useEffect(() => {
    const now = moment().add(10, "days").toDate();

    if (user)
      if (user?.passwordExpiryDate) {
        if (new Date(user.passwordExpiryDate) < now) {
          setIsExpired(true);
        }
      } else if (!String(window.location).includes("changepassword")) {
        setIsFirstLogin(true);
      }
  }, [user]);

  return (
    <>
      <MessageBox
        visible={false}//logout
        message="You have logged in from other tab/window, you will be logged out"
        title={"Multiple login is detected"}
        type="warning"
        closeHandler={() => {
        }}
      ></MessageBox>
      <MessageBox
        visible={isExpired || isFirstLogin}
        message={isFirstLogin ? firstloginMsg : expiredMsg}
        title={isFirstLogin ? "Setup New Password" : "Expired Password"}
        type="warning"
        closeHandler={() => {
          setIsExpired(false);
          setIsFirstLogin(false);
          if (isFirstLogin) navigate("/profile/change-password");
        }}
      ></MessageBox>
      <div className="">{incomingcallcontrol}</div>
      <div className="h-[54px] flex items-center bg-primary px-1 md:px-5  py-4">
        <div className="container flex items-center justify-between gap-2">
          <div className="header-left flex items-center">
            <Logo />
            <MainMenu menu={navigations} />
          </div>

          <div className="header-right flex items-center">
            <div className="rounded-full bg-white nowrap h-[30px] flex flex-row items-center pl-[12px] pr-2 mr-2 gap-[6px]">
              <PresenceSwitch
                durationFrom={reasonTime}
                checkState={{
                  chatConnected,
                  chatServerConnected,
                  vcallConnected,
                  sipConnected,
                  callpresence
                }}
              />
              <div className="h-[50%] w-[1px] bg-gray-200"></div>
              {callpresence?.trim() === "" &&
                ping >= 0 &&
                chatConnected &&
                vcallConnected && (
                  <>
                    <SignalIndicator
                      ping={String(ping)}
                      threshold1={800}
                      threshold2={2000}
                    ></SignalIndicator>
                    <div className="text-white text-sm">{reasonLabel}</div>
                  </>
                )}
              {callpresence?.trim() !== "" && (
                <div className="font-semibold text-gray-900 text-base">
                  {callpresence}
                </div>
              )}
              {reasonLabel !== "" && reasonLabel?.length < 11 &&(
                <div className="font-semibold text-gray-900 text-base">
                  {reasonLabel.replace(/\b\w/g, (l: any) => l.toUpperCase())}
                </div>
              )}
              {reasonLabel !== "" && reasonLabel?.length > 10 &&(
                <div className="font-semibold text-gray-900 text-sm">
                  {reasonLabel.replace(/\b\w/g, (l: any) => l.toUpperCase())}
                </div>
              )}
              <PresenceDropdown
                checkState={{
                  chatConnected,
                  vcallConnected,
                  sipConnected,
                  callpresence
                }}
                onChange={ChangeState}
              ></PresenceDropdown>
            </div>
            <NotificationInternalDropdown />
            <UserDropdown
              roleDescription={user?.cmRoleDescription}
              fullname={user?.fullname}
              profilePicture={user?.profilePicture}
            />

            <BurgerButton
              label="Click here to open offcanvas menu"
              onClick={offcanvasHandler}
              className="ml-[0.938rem] lg:hidden"
            />
          </div>
        </div>
      </div>
      <MobileMenu
        data={navigations}
        isOpen={offcanvas}
        onClosed={offcanvasHandler}
      />
    </>
  );
};

export default Header;
